import stores from './stores';

export const UTM_MEDIUM = 'admin';
export const UTM_MEDIUM_GROUPS = 'group_bookings';
export const UTM_MEDIUM_INTERNAL_WHOLESALE = 'internal_wholesale';
export const LE_LABEL = 'luxuryescapes';
export const LE_ATTRIBUTION = 'luxuryescapes';

export type UtmMediumOption = {
  label: string;
  value: string;
  enabled: boolean;
};

export const UTM_MEDIUM_OPTIONS: Array<UtmMediumOption> = [
  { label: 'Contact Centre', value: UTM_MEDIUM, enabled: true },
  { label: stores.chadstone_store.displayName, value: stores.chadstone_store.utmMedium, enabled: true },
  { label: stores.bondi_store.displayName, value: stores.bondi_store.utmMedium, enabled: true },
  { label: stores.chermside_store.displayName, value: stores.chermside_store.utmMedium, enabled: true },
  { label: stores.le_live.displayName, value: stores.le_live.utmMedium, enabled: false },
  { label: 'Group Bookings', value: UTM_MEDIUM_GROUPS, enabled: true },
  { label: 'Internal Wholesale', value: UTM_MEDIUM_INTERNAL_WHOLESALE, enabled: true },
];

export const ENABLED_UTM_MEDIUM_OPTIONS = UTM_MEDIUM_OPTIONS.filter((option) => option.enabled);

/**
 * Selectable mediums for an order, keeping a legacy or otherwise unlisted current value visible so
 * an edit never silently drops it. LE Live is never selectable, so a current LE Live value shows
 * disabled.
 */
export function getUtmMediumOptionsForOrder(currentUtmMedium?: string | null): Array<UtmMediumOption> {
  const options = [...ENABLED_UTM_MEDIUM_OPTIONS];

  if (currentUtmMedium && !options.some((option) => option.value === currentUtmMedium)) {
    options.unshift({
      label: currentUtmMedium,
      value: currentUtmMedium,
      enabled: currentUtmMedium !== stores.le_live.utmMedium,
    });
  }

  return options;
}

export function getUtmMediumLabel(utmMedium?: string | null): string {
  if (!utmMedium) {
    return '—';
  }

  return UTM_MEDIUM_OPTIONS.find((option) => option.value === utmMedium)?.label ?? utmMedium;
}

export const brands = [
  {
    title: 'Luxury Escapes',
    value: 'luxuryescapes',
    sailthru: '9d220dfb0bb97ebaaa372ce80a85c465',
  },
  {
    title: 'Cudo',
    value: 'cudo',
    sailthru: '58e9cf5da179a48132ebc71a877910dc',
  },
  {
    title: 'Ouffer',
    value: 'ouffer',
    sailthru: null,
  },
  {
    title: 'Deals',
    value: 'deals',
    sailthru: 'f33be26942ffa3c84af3f7276f739801',
  },
  {
    title: 'Treat Me',
    value: 'treatme',
    sailthru: 'c81ee857b89b857431e7768a0ed6f151',
  },
  {
    title: 'Living Social',
    value: 'livingsocial',
    sailthru: '3f8da786448e372298e1f5becb459912',
  },
  // To be refactored for header brand toggle
  {
    title: 'Scoopon Travel',
    value: 'scoopontravel',
    sailthru: '',
  },
  // may be need a value here
  {
    title: 'Kogan Travel',
    value: 'kogantravel',
    sailthru: '',
  },
];
